import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  Stack,
  Chip,
  
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const apiUrl = process.env.REACT_APP_API_URL;

const DashboardPage = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
    const [userRole, setUserRole] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalLogs, setTotalLogs] = useState(0);

    const [allPaused, setAllPaused] = useState(false); // track current state
  
   
    

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    setLoading(true);

    axiosInstance
      .get(
        `${apiUrl}/all-logs?page=${
          page + 1
        }&limit=${rowsPerPage}&search=${searchQuery}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        setLogs(Array.isArray(response.data.logs) ? response.data.logs : []);
        setTotalLogs(response.data.total || 0); // ✅ Store total logs count
        setUserInfo(response.data?.username || "User");
         setUserRole(response.data?.role);
      })
      .catch((err) => {
        console.error("Error fetching logs:", err);
        setError("Failed to load logs.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, rowsPerPage, searchQuery]); // ✅ Include searchQuery

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleToggleAllCrons = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const action = allPaused ? "resume" : "pause";
  
      const response = await axiosInstance.post(`${apiUrl}/all-crons/toggle`, { action }, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      toast.success(response.data.message);
      window.location.reload(); // 🔁 Reload page to reflect updated cron states

      // setAllPaused(!allPaused); // flip state
      // fetchCrons(); // refresh data
    } catch (error) {
      toast.error("Failed to toggle cron jobs");
      console.error("Toggle error:", error);
    }
  };

  useEffect(() => {
    const allInactive = logs.length > 0 && logs.every((log) => !log.active);
    setAllPaused(allInactive);
  }, [logs]);
  


  return (
    <Box p={3}>
      {/* Top Bar: Username & Logout */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h5">Dashboard</Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="subtitle1">Welcome, {userInfo}</Typography>
          <Button variant="contained" color="secondary" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </Box>

      {(userRole === "Admin" || userRole === "Vendor") ? (
      <>

      {/* Search Input */}
      <Stack
  direction="row"
  spacing={2}
  alignItems="center"
  sx={{ mb: 2 }}
>
  {/* Search Input - Not fullWidth now */}
  <TextField
    label="Search Logs"
    variant="outlined"
    value={searchQuery}
    onChange={handleSearchChange}
    sx={{ width: 1000 }}
  />

  {/* Pause/Resume Button */}
  <Button
    variant="outlined"
    color="warning"
    onClick={handleToggleAllCrons}
    sx={{ minWidth: 200 }}
  >
    {allPaused ? "Resume All Crons" : "Pause All Crons"}
  </Button>
</Stack>


      {/* Table */}
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : logs.length > 0 ? (
        <TableContainer component={Paper} sx={{ width: "100%", mt: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Type</b>
                </TableCell>
                <TableCell>
                  <b>Vendor ID</b>
                </TableCell>
                <TableCell>
                  <b>Vendor Name</b>
                </TableCell>
                <TableCell>
                  <b>User ID</b>
                </TableCell>
                <TableCell>
                  <b>Link/Host</b>
                </TableCell>
                <TableCell>
                  <b>Status</b>
                </TableCell>
                <TableCell>
                  <b>CRON Status</b>
                </TableCell>
                <TableCell>
                  <b>Count</b>
                </TableCell>
                <TableCell>
                  <b>Matched</b>
                </TableCell>
                <TableCell>
                  <b>Unmatched</b>
                </TableCell>
                <TableCell>
                  <b>Created At</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log, index) => (
                <TableRow key={index}>
                  <TableCell>{log.type}</TableCell>
                  <TableCell>{log.vendorId}</TableCell>
                  <TableCell>{log.vendorName}</TableCell>
                  <TableCell>{log.userId}</TableCell>
                  <TableCell>{log.dropboxLink || log.host}</TableCell>
                  <TableCell>{log.status}</TableCell>
                   <TableCell>
                                                      <Chip
                                                        label={log.active ? "Active" : "Paused"}
                                                        color={log.active ? "success" : "error"}
                                                        size="small"
                                                      
                                                      />
                                                    </TableCell>
                  <TableCell>{log.count}</TableCell>
                  <TableCell>{log.matches}</TableCell>
                  <TableCell>{log.unmatched}</TableCell>
                  <TableCell>
                    {new Date(log.createdAt).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography>No logs available.</Typography>
      )}

      {/* Pagination */}
      {logs.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={totalLogs} // ✅ Use total count from backend
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ mt: 2 }}
        />
      )}
             </>
    ) : (
      <Typography variant="h6" mt={5}>
        Welcome, {userInfo}.
      </Typography>
    )}

    </Box>
  );
};

export default DashboardPage;
